<template>
    <el-popover
        v-model="visible"
        :visible-arrow="false"
        placement="bottom-start"
        width="440"
        trigger="click"
    >
        <div
            class="flex h-[280px]"
            :style="{ 'border-bottom': '1px solid #e3e3e3' }"
        >
            <div
                class="w-[240px]"
                :style="{ 'border-right': '1px solid #e3e3e3' }"
            >
                <LeftMenuNode
                    v-for="(item, index) in filter_options"
                    :key="index"
                    :node="item"
                    :visible="visible"
                    :num_rendered="num_rendered"
                    :selected_list_values="selected_list_values"
                    :active_filter.sync="active_filter"
                    :level="1"
                ></LeftMenuNode>
            </div>
            <div class="w-[200px]">
                <RightContent
                    v-show="active_filter"
                    :active_filter="active_filter"
                    :num_rendered.sync="num_rendered"
                    :selected_list_values.sync="selected_list_values"
                ></RightContent>
            </div>
        </div>
        <div class="px-3 py-2 flex items-center">
            <div class="ml-auto">
                <el-button
                    slot="reference"
                    type="primary"
                    size="mini"
                    @click="handleChangeFiltering"
                >
                    {{ $t('button.apply') }}
                </el-button>
            </div>
        </div>
        <el-button
            slot="reference"
            icon="el-icon-s-operation"
            class="min-w-[92px]"
            size="small"
            type="info"
            plain
        >
            {{ $t('button.filters') }}
        </el-button>
    </el-popover>
</template>

<script>
import LeftMenuNode from './left-menu-node'
import RightContent from './right-content'

export default {
    components: {
        LeftMenuNode,
        RightContent
    },

    props: ['handle_change_filtering', 'filtering'],

    data() {
        return {
            num_rendered: 0,
            visible: false,
            active_filter: undefined,
            selected_list_values: {},
            filter_options: [
                {
                    title: this.$t('common.status'),
                    children: [
                        {
                            title: this.$t('common.xxx_status', {
                                xxx: this.$t('common.campaign')
                            }),
                            value: 'campaign_status',
                            right_children: [
                                {
                                    title: this.$t('common.active'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELIVERY_OK
                                },
                                {
                                    title: this.$t('common.not_delivering'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_NOT_DELIVERY
                                },
                                {
                                    title: this.$t('common.inactive'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DISABLE
                                },
                                {
                                    title: this.$t('common.deleted'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELETE
                                }
                            ]
                        },
                        {
                            title: this.$t('common.xxx_status', {
                                xxx: this.$t('common.adgroup')
                            }),
                            value: 'adgroup_status',
                            right_children: [
                                {
                                    title: this.$t('common.active'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELIVERY_OK
                                },
                                {
                                    title: this.$t('common.not_delivering'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_NOT_DELIVERY
                                },
                                {
                                    title: this.$t('common.inactive'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DISABLE
                                },
                                {
                                    title: this.$t('common.completed'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_TIME_DONE
                                },
                                {
                                    title: this.$t('common.deleted'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELETE
                                },
                                {
                                    title: this.$t('common.closed'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_RF_CLOSED
                                }
                            ]
                        },
                        {
                            title: this.$t('common.xxx_status', {
                                xxx: this.$t('common.ad')
                            }),
                            value: 'ad_status',
                            right_children: [
                                {
                                    title: this.$t('common.active'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELIVERY_OK
                                },
                                {
                                    title: this.$t('common.not_delivering'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_NOT_DELIVERY
                                },
                                {
                                    title: this.$t('common.inactive'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DISABLE
                                },
                                {
                                    title: this.$t('common.deleted'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_DELETE
                                },
                                {
                                    title: this.$t('common.closed'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_RF_CLOSED
                                },
                                {
                                    title: this.$t('common.completed'),
                                    value: this.p__list_advertiser_status
                                        .STATUS_TIME_DONE
                                }
                            ]
                        }
                    ]
                }
                // {
                //     title: 'Objectives',
                //     value: 'objective_type',
                //     right_children: [
                //         {
                //             title: 'Conversions',
                //             value: '3'
                //         },
                //         {
                //             title: 'Traffic',
                //             value: '1,11'
                //         },
                //         {
                //             title: 'App Installs',
                //             value: '2,13'
                //         },
                //         {
                //             title: 'App promotion',
                //             value: '16'
                //         },
                //         {
                //             title: 'Video views',
                //             value: '4,10'
                //         },
                //         {
                //             title: 'Reach',
                //             value: '5,7'
                //         },
                //         {
                //             title: 'Product sales',
                //             value: '15'
                //         },
                //         {
                //             title: 'Catalog sales',
                //             value: '6'
                //         },
                //         {
                //             title: 'Shop purchases',
                //             value: '14'
                //         },
                //         {
                //             title: 'Lead generation',
                //             value: '8'
                //         },
                //         {
                //             title: 'Community interaction',
                //             value: '0,12'
                //         }
                //     ]
                // }
            ]
        }
    },

    watch: {
        filtering() {
            this.selected_list_values = {}

            if (!this.filtering.length) {
                return
            }
            for (const item of this.filtering) {
                this.selected_list_values[item.field_name] = JSON.parse(
                    item.filter_value
                )
            }
        }
    },

    methods: {
        handleChangeFiltering() {
            for (const [key, value] of Object.entries(
                this.selected_list_values
            )) {
                this.handle_change_filtering(key, value)
            }

            this.visible = false
        }
    }
}
</script>
